/* eslint-disable */

export const LIGHT_INTENSITY = 1
export const LIGHT_SKY_COLOR =    [0.5, 0.5, 0.5]
export const LIGHT_GROUND_COLOR = [0.5, 0.5, 0.5]
export const CAMERA_POSITION =    { x: 0, y: 0, z: -1.5 }
export const LIGHT_POSITION =     { x: 0, y: 1, z: 0 }

export const CAMERA_LOADING_POSITION = { x: 0, y: 0, z: -15 }

export const COIN_TESSELLATION = 75
export const COIN_HEIGHT = 0.035
export const CAMERA_MIN =  0.1
export const CAMERA_MAX =  1000

export const CAMERA_DISTANCE_MIN = 1.2
export const CAMERA_DISTANCE_MAX = 15

export const SMOOTH_FLIP_COEFF = 0.15
export const SMOOTH_ZOOM_COEFF = 0.075

export const LOADING_MAT = {
  type: 'standard',
  name: 'coin-loading',
  albedoColor:   [1.0, 1.0, 1.0],
  emissiveColor: [1.0, 1.0, 1.0],
  specularColor: [0, 0, 0],
}

export const DEFAULT_MAT = {
  type: 'PBR',
  name: 'coin-mat',
  albedoColor:       [0.8, 0.63, 0.19], // [0.8, 0.63, 0.19],//[0.9, 0.7, 0.3], // [1.0, 0.925, 0.45], /*/ [1, 1, 1], */ // [1.0, 0.766, 0.336], [0.8, 0.63, 0.19]
  specularColor:     [0, 0, 0],
  specularIntensity: 0.0,
  emissiveColor:     [0.0, 0.0, 0.0],
  metallic:  0.99,   // 0.75, // 1.0, // 0.8,
  roughness: 0.2,    // 0.175, // 0.2, // 0.1,
  environmentIntensity: 1,
  indexOfRefraction: 2,
  normalMap: '%STATICS%/normalmaps/normalmap-generate.png',
  envMap:    '%STATICS%/envmaps/mdp004-blur.env',
}
